import * as React from "react"
import { cva } from "class-variance-authority"

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-xl text-base font-medium transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default:
          "bg-[hsl(var(--primary))] text-white shadow-[var(--shadow-md)] hover:bg-[hsl(var(--primary-dark))] hover:shadow-[var(--shadow-lg)] hover:scale-105 active:scale-95",
        secondary:
          "bg-[hsl(var(--secondary))] text-white shadow-[var(--shadow-md)] hover:bg-[hsl(var(--accent-warm))] hover:shadow-[var(--shadow-lg)] hover:scale-105 active:scale-95",
        outline:
          "border-2 border-[hsl(var(--primary))] text-[hsl(var(--primary))] bg-transparent hover:bg-[hsl(var(--primary))] hover:text-white hover:scale-105 active:scale-95",
        ghost:
          "text-[hsl(var(--primary))] hover:bg-[hsl(var(--muted))] hover:text-[hsl(var(--primary-dark))]",
        link:
          "text-[hsl(var(--primary))] underline-offset-4 hover:underline",
        premium:
          "bg-gradient-to-r from-[hsl(var(--primary))] to-[hsl(var(--secondary))] text-white shadow-[var(--shadow-xl)] hover:shadow-[var(--shadow-glow)] hover:scale-105 active:scale-95",
      },
      size: {
        default: "h-12 px-6 py-3",
        sm: "h-10 px-4 py-2 text-sm",
        lg: "h-14 px-8 py-4 text-lg",
        icon: "h-12 w-12",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(
  ({ className = "", variant, size, ...props }, ref) => {
    return (
      <button
        className={`${buttonVariants({ variant, size })} ${className}`}
        ref={ref}
        {...props}
      />
    )
  }
)
Button.displayName = "Button"

export { Button, buttonVariants }